import type React from "react";

export function Logomark({
  className,
  invert = false,
  ...props
}: React.ComponentPropsWithoutRef<"svg"> & {
  invert?: boolean;
}) {
  return (
    <svg
      className={className}
      fill="none"
      height={54}
      viewBox="0 0 75 75"
      width={54}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M53.5846 26.8026C53.5846 41.6053 41.5893 53.6052 26.7923 53.6052C11.9953 53.6052 0 41.6053 0 26.8026C0 11.9999 11.9953 0 26.7923 0C41.5893 0 53.5846 11.9999 53.5846 26.8026ZM13.914 20.9706H8.02722L14.4423 12.4391H25.6875V25.9536H22.8196V41.1292H13.914V20.9706ZM38.9705 12.4391L45.3855 20.9707H39.4988V41.1292H30.5931V25.9537H27.7252V12.4391H38.9705Z"
        fill={invert ? "#ffffff" : "url(#paint0_linear_2_1746)"}
        fillRule="evenodd"
      />

      {!invert && (
        <defs>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint0_linear_2_1746"
            x1="188.724"
            x2="9.42563e-07"
            y1="26.8026"
            y2="26.8026"
          >
            <stop stopColor="#02A8EA" />
            <stop offset="1" stopColor="#0670CB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint1_linear_2_1746"
            x1="188.724"
            x2="9.42563e-07"
            y1="26.8026"
            y2="26.8026"
          >
            <stop stopColor="#02A8EA" />
            <stop offset="1" stopColor="#0670CB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint2_linear_2_1746"
            x1="188.724"
            x2="9.42563e-07"
            y1="26.8026"
            y2="26.8026"
          >
            <stop stopColor="#02A8EA" />
            <stop offset="1" stopColor="#0670CB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint3_linear_2_1746"
            x1="188.724"
            x2="9.42563e-07"
            y1="26.8026"
            y2="26.8026"
          >
            <stop stopColor="#02A8EA" />
            <stop offset="1" stopColor="#0670CB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint4_linear_2_1746"
            x1="188.724"
            x2="9.42563e-07"
            y1="26.8026"
            y2="26.8026"
          >
            <stop stopColor="#02A8EA" />
            <stop offset="1" stopColor="#0670CB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint5_linear_2_1746"
            x1="188.724"
            x2="9.42563e-07"
            y1="26.8026"
            y2="26.8026"
          >
            <stop stopColor="#02A8EA" />
            <stop offset="1" stopColor="#0670CB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint6_linear_2_1746"
            x1="188.724"
            x2="9.42563e-07"
            y1="26.8026"
            y2="26.8026"
          >
            <stop stopColor="#02A8EA" />
            <stop offset="1" stopColor="#0670CB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint7_linear_2_1746"
            x1="188.724"
            x2="9.42563e-07"
            y1="26.8026"
            y2="26.8026"
          >
            <stop stopColor="#02A8EA" />
            <stop offset="1" stopColor="#0670CB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint8_linear_2_1746"
            x1="188.724"
            x2="9.42563e-07"
            y1="26.8026"
            y2="26.8026"
          >
            <stop stopColor="#02A8EA" />
            <stop offset="1" stopColor="#0670CB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint9_linear_2_1746"
            x1="188.724"
            x2="9.42563e-07"
            y1="26.8026"
            y2="26.8026"
          >
            <stop stopColor="#02A8EA" />
            <stop offset="1" stopColor="#0670CB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint10_linear_2_1746"
            x1="188.724"
            x2="9.42563e-07"
            y1="26.8026"
            y2="26.8026"
          >
            <stop stopColor="#02A8EA" />
            <stop offset="1" stopColor="#0670CB" />
          </linearGradient>
        </defs>
      )}
    </svg>
  );
}

export function Logo({
  className,
  invert = false,
  ...props
}: React.ComponentPropsWithoutRef<"svg"> & {
  invert?: boolean;
}) {
  return (
    <svg
      className={className}
      fill="none"
      height={54}
      viewBox="0 0 189 54"
      width={189}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M53.5846 26.8026C53.5846 41.6053 41.5893 53.6052 26.7923 53.6052C11.9953 53.6052 0 41.6053 0 26.8026C0 11.9999 11.9953 0 26.7923 0C41.5893 0 53.5846 11.9999 53.5846 26.8026ZM13.914 20.9706H8.02722L14.4423 12.4391H25.6875V25.9536H22.8196V41.1292H13.914V20.9706ZM38.9705 12.4391L45.3855 20.9707H39.4988V41.1292H30.5931V25.9537H27.7252V12.4391H38.9705Z"
        fill={invert ? "#ffffff" : "url(#paint0_linear_2_1746)"}
        fillRule="evenodd"
      />
      <path
        d="M69.8447 20.2014L64.411 20.7317V17.2846L71.7001 16.2239L78.9893 17.2846V20.7317L73.6881 20.2014V35.7134H69.7122V20.2014H69.8447Z"
        fill={invert ? "#ffffff" : "url(#paint1_linear_2_1746)"}
      />
      <path
        d="M84.9531 22.0575C88.9291 22.0575 91.5797 24.9743 91.5797 29.3495V30.145H81.6399C81.905 31.8685 83.2303 33.1943 85.4833 33.1943C86.676 33.1943 88.1339 32.664 89.0616 31.8685L90.6519 34.1224C89.3266 35.3156 87.2062 35.9785 85.2182 35.9785C81.1098 35.9785 78.0616 33.1943 78.0616 28.9517C77.9291 25.1069 80.8447 22.0575 84.9531 22.0575ZM81.6399 27.7585H88.2664C88.1339 26.4327 87.3387 24.8417 84.9531 24.8417C82.7001 24.8417 81.7724 26.4327 81.6399 27.7585Z"
        fill={invert ? "#ffffff" : "url(#paint2_linear_2_1746)"}
      />
      <path
        d="M94.0977 17.2846H97.5435V35.7134H94.0977V17.2846Z"
        fill={invert ? "#ffffff" : "url(#paint3_linear_2_1746)"}
      />
      <path
        d="M107.086 22.0575C111.062 22.0575 113.712 24.9743 113.712 29.3495V30.145H103.772C104.037 31.8685 105.363 33.1943 107.616 33.1943C108.809 33.1943 110.266 32.664 111.194 31.8685L112.784 34.1224C111.459 35.3156 109.339 35.9785 107.351 35.9785C103.242 35.9785 100.194 33.1943 100.194 28.9517C100.194 25.1069 103.11 22.0575 107.086 22.0575ZM103.772 27.7585H110.399C110.266 26.4327 109.471 24.8417 107.086 24.8417C104.965 24.8417 104.037 26.4327 103.772 27.7585Z"
        fill={invert ? "#ffffff" : "url(#paint4_linear_2_1746)"}
      />
      <path
        d="M118.218 20.2014L112.784 20.7317V17.2846L120.074 16.2239L127.363 17.2846V20.7317L122.062 20.2014V35.7134H118.086V20.2014H118.218Z"
        fill={invert ? "#ffffff" : "url(#paint5_linear_2_1746)"}
      />
      <path
        d="M128.025 22.3227H131.471V24.1788C132.399 22.9856 134.122 22.0575 135.712 22.0575V25.5046C135.447 25.5046 135.182 25.372 134.784 25.372C133.592 25.372 132.134 26.0349 131.471 26.8304V35.5808H128.025V22.3227Z"
        fill={invert ? "#ffffff" : "url(#paint6_linear_2_1746)"}
      />
      <path
        d="M145.917 34.3876C144.989 35.4482 143.399 36.1111 141.676 36.1111C139.556 36.1111 137.037 34.6527 137.037 31.7359C137.037 28.554 139.556 27.4933 141.676 27.4933C143.399 27.4933 144.989 28.0237 145.917 29.0843V27.2282C145.917 25.9024 144.724 24.9743 143.001 24.9743C141.544 24.9743 140.218 25.5046 139.158 26.5653L137.833 24.1788C139.423 22.7204 141.544 22.0575 143.664 22.0575C146.712 22.0575 149.495 23.2507 149.495 27.0956V35.7134H145.917V34.3876ZM145.917 30.8079C145.387 30.0124 144.194 29.6146 143.134 29.6146C141.809 29.6146 140.616 30.2775 140.616 31.6033C140.616 32.7966 141.809 33.5921 143.134 33.5921C144.327 33.5921 145.387 33.1943 145.917 32.3988V30.8079Z"
        fill={invert ? "#ffffff" : "url(#paint7_linear_2_1746)"}
      />
      <path
        d="M162.086 33.9898C161.025 35.3156 159.568 35.9785 157.977 35.9785C154.664 35.9785 152.013 33.4595 152.013 28.9517C152.013 24.5766 154.531 21.9249 157.977 21.9249C159.568 21.9249 161.025 22.5878 162.086 23.9136V17.152H165.664V35.5808H162.086V33.9898ZM162.086 26.6979C161.556 25.7698 160.23 25.2395 159.037 25.2395C157.05 25.2395 155.724 26.8304 155.724 29.0843C155.724 31.3382 157.05 32.9292 159.037 32.9292C160.23 32.9292 161.556 32.2663 162.086 31.4708V26.6979Z"
        fill={invert ? "#ffffff" : "url(#paint8_linear_2_1746)"}
      />
      <path
        d="M168.712 18.3452C168.712 17.152 169.64 16.2239 170.833 16.2239C172.025 16.2239 172.953 17.152 172.953 18.3452C172.953 19.5385 172.025 20.4665 170.833 20.4665C169.64 20.4665 168.712 19.5385 168.712 18.3452ZM169.11 22.3227H172.556V35.7134H169.11V22.3227Z"
        fill={invert ? "#ffffff" : "url(#paint9_linear_2_1746)"}
      />
      <path
        d="M182.098 22.0575C186.074 22.0575 188.724 24.9743 188.724 29.3495V30.145H178.784C179.05 31.8685 180.375 33.1943 182.628 33.1943C183.821 33.1943 185.278 32.664 186.206 31.8685L187.797 34.1224C186.471 35.3156 184.351 35.9785 182.363 35.9785C178.254 35.9785 175.206 33.1943 175.206 28.9517C175.206 25.1069 177.989 22.0575 182.098 22.0575ZM178.784 27.7585H185.411C185.278 26.4327 184.483 24.8417 182.098 24.8417C179.845 24.8417 178.917 26.4327 178.784 27.7585Z"
        fill={invert ? "#ffffff" : "url(#paint10_linear_2_1746)"}
      />
      {!invert && (
        <defs>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint0_linear_2_1746"
            x1="188.724"
            x2="9.42563e-07"
            y1="26.8026"
            y2="26.8026"
          >
            <stop stopColor="#02A8EA" />
            <stop offset="1" stopColor="#0670CB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint1_linear_2_1746"
            x1="188.724"
            x2="9.42563e-07"
            y1="26.8026"
            y2="26.8026"
          >
            <stop stopColor="#02A8EA" />
            <stop offset="1" stopColor="#0670CB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint2_linear_2_1746"
            x1="188.724"
            x2="9.42563e-07"
            y1="26.8026"
            y2="26.8026"
          >
            <stop stopColor="#02A8EA" />
            <stop offset="1" stopColor="#0670CB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint3_linear_2_1746"
            x1="188.724"
            x2="9.42563e-07"
            y1="26.8026"
            y2="26.8026"
          >
            <stop stopColor="#02A8EA" />
            <stop offset="1" stopColor="#0670CB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint4_linear_2_1746"
            x1="188.724"
            x2="9.42563e-07"
            y1="26.8026"
            y2="26.8026"
          >
            <stop stopColor="#02A8EA" />
            <stop offset="1" stopColor="#0670CB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint5_linear_2_1746"
            x1="188.724"
            x2="9.42563e-07"
            y1="26.8026"
            y2="26.8026"
          >
            <stop stopColor="#02A8EA" />
            <stop offset="1" stopColor="#0670CB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint6_linear_2_1746"
            x1="188.724"
            x2="9.42563e-07"
            y1="26.8026"
            y2="26.8026"
          >
            <stop stopColor="#02A8EA" />
            <stop offset="1" stopColor="#0670CB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint7_linear_2_1746"
            x1="188.724"
            x2="9.42563e-07"
            y1="26.8026"
            y2="26.8026"
          >
            <stop stopColor="#02A8EA" />
            <stop offset="1" stopColor="#0670CB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint8_linear_2_1746"
            x1="188.724"
            x2="9.42563e-07"
            y1="26.8026"
            y2="26.8026"
          >
            <stop stopColor="#02A8EA" />
            <stop offset="1" stopColor="#0670CB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint9_linear_2_1746"
            x1="188.724"
            x2="9.42563e-07"
            y1="26.8026"
            y2="26.8026"
          >
            <stop stopColor="#02A8EA" />
            <stop offset="1" stopColor="#0670CB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint10_linear_2_1746"
            x1="188.724"
            x2="9.42563e-07"
            y1="26.8026"
            y2="26.8026"
          >
            <stop stopColor="#02A8EA" />
            <stop offset="1" stopColor="#0670CB" />
          </linearGradient>
        </defs>
      )}
    </svg>
  );
}
